module.exports = __webpack_public_path__ + "static/media/plan_question_theory.12885b35.png";